import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { SliceyMessage } from '../types/messageTypes'

// Client-only state for the Slicey AI drawer:
//   - drawerOpen     : FAB / AppLayout toggle this
//   - messages       : in-session conversation history; persists across drawer
//                      close/reopen, resets on hard reload
//
// Each backend POST is independent today, so history lives here rather than
// in the TanStack cache. Move to a `useSliceyThreadQuery` once the API ships
// thread persistence.
export const useAskSliceyStore = defineStore('askSlicey', () => {
  const drawerOpen = ref(false)
  // TODO(§4): migrate to useSliceyThreadQuery when the API ships thread
  // persistence. Today each POST is independent so history lives client-side.
  const messages = ref<SliceyMessage[]>([])

  const openDrawer = () => {
    drawerOpen.value = true
  }

  const closeDrawer = () => {
    drawerOpen.value = false
  }

  const appendMessage = (message: SliceyMessage) => {
    messages.value.push(message)
  }

  const resetConversation = () => {
    messages.value = []
  }

  return {
    drawerOpen,
    messages,
    openDrawer,
    closeDrawer,
    appendMessage,
    resetConversation,
  }
})
